/**
 * Formats number as currency.
 *
 * Currently only supports USD.
*/
export function currency(number) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    return formatter.format(number);
}
